var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacilityOffice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25001 32.8501V4.0501C7.25001 3.2014 7.58715 2.38747 8.18726 1.78736C8.78738 1.18724 9.60131 0.850098 10.45 0.850098H23.25C24.0987 0.850098 24.9126 1.18724 25.5127 1.78736C26.1129 2.38747 26.45 3.2014 26.45 4.0501V32.8501M7.25001 32.8501H26.45M7.25001 32.8501H4.05001C3.20131 32.8501 2.38738 32.513 1.78726 31.9128C1.18715 31.3127 0.850006 30.4988 0.850006 29.6501V20.0501C0.850006 19.2014 1.18715 18.3875 1.78726 17.7874C2.38738 17.1872 3.20131 16.8501 4.05001 16.8501H7.25001M26.45 32.8501H29.65C30.4987 32.8501 31.3126 32.513 31.9127 31.9128C32.5129 31.3127 32.85 30.4988 32.85 29.6501V15.2501C32.85 14.4014 32.5129 13.5875 31.9127 12.9874C31.3126 12.3872 30.4987 12.0501 29.65 12.0501H26.45M13.65 7.2501H20.05M13.65 13.6501H20.05M13.65 20.0501H20.05M13.65 26.4501H20.05",
    stroke: "#565D6D",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityOffice);
export default __webpack_public_path__ + "static/media/facility-office.64610fb2239fa1b9371bfe48a8b96c6a.svg";
export { ForwardRef as ReactComponent };